<template>
  <div class="van-cell-wrap">
    <van-field v-model="value" @click="handleClickSelect()" :label="label"
               :right-icon="!readonly ? 'arrow':''" :readonly="true" :disabled="disabled"
               placeholder="请选择" :rules="[{ required:required, message: '请选择' }]">
      <template slot="label">
        <div @click="onClickLabel"
             :class="{ 'van-cell__title': true, 'van-field__label': true, 'van-icon': showHelpIcon , 'van-icon-question': showHelpIcon }">
          <span>{{ label }}</span>
        </div>
      </template>
    </van-field>

    <div></div>
    <van-popup v-model="isPopShow" position="bottom">
      <van-picker show-toolbar :columns="selectList" @cancel="isPopShow=false" @confirm="handleClickConfirm"
                  v-model="value"/>
    </van-popup>
  </div>
</template>

<script>
import {
  getSysDict
} from '@/utils/sys-dict.js'

export default {
  name: 'SysDict',
  props: {
    dictName: String,
    label: String,
    value: null,
    showHelpIcon: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: false,
  },
  data() {
    return {
      isPopShow: false,
      selectList: [],
    }
  },
  methods: {
    onClickLabel(e) {
      if (this.showHelpIcon) {
        e.stopPropagation();
        this.$emit('clickLabel')
      }
    },
    handleClickSelect() {
      if (this.readonly) {
        return;
      }
      this.isPopShow = true
      this.selectList = getSysDict(this.dictName).map((item) => {
        return item.label || item.value
      })
    },
    handleClickConfirm(newValue) {
      this.$emit('input', newValue)
      this.$emit('changeObject', getSysDict(this.dictName).find((item) => {
        return item.label === newValue || item.value === newValue
      }))
      this.isPopShow = false
    }
  }
}
</script>
<style scoped>

</style>
